import React,{useState,useEffect} from "react";
import Notifications from "../../components/Notification/Notifications";
import "./NotificationPage.css";
import history from "../../routes/history";
export default function NotificationPage() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    if(windowDimensions.width > 768){
    history.push("/employerdashboard")
    }
    }, [windowDimensions]);

  return (
    <div className="NotificationScreen">
      <div className="cont">
        <Notifications />
      </div>
    </div>
  );
}
